module.exports = __webpack_public_path__ + "front/img/edm-intro.7985bf24.png";